import React from "react";
import { useTranslation } from "react-i18next";

export const TradePendingDoneButton = ({ onClick }: { onClick: () => void }) => {
    const { t } = useTranslation();

    return (
        <div className="TradePending__done--container">
            <button className="TradePending__done--button" id="TradePendingDone" onClick={onClick}>
                {t("TradePending.doneEditing")}
            </button>
        </div>
    );
};
